__webpack_require__.p = "/Bookstore/";